import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment, useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import { getSessionItem } from '@atlassian/search-dialog';
import { useAIAnswerContext } from '../../../../ai-answer-context';
import { SEARCH_AI_ANSWER_CACHE_KEY } from '../../../../ai-answer-dialog';
import { onRecentWorkLinkClick, onRecentWorkLinkContextMenuClick } from '../../../../analytics';
import { messages } from './messages';
import { RecentWorkItem } from './recent-work-item';
import { EmptyStateTextWrapper, LinkWrapper, RecentWorkListTitle, RecentWorkListWrapper } from './styled';
var COLLAPSED_RECENT_WORK_ITEM_NUMBER = 5;
export var RecentWorkList = function RecentWorkList(_ref) {
  var name = _ref.name,
    activities = _ref.activities,
    viewAllUrl = _ref.viewAllUrl;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var cachedExpanded = JSON.parse(getSessionItem(SEARCH_AI_ANSWER_CACHE_KEY) || '{}').recentWorkListExpanded;
  var _useState = useState(cachedExpanded !== undefined ? cachedExpanded : false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useAIAnswerContext = useAIAnswerContext(),
    updateContextCache = _useAIAnswerContext.updateContextCache,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    commonAttributes = _useAIAnswerContext.commonAttributes,
    onNavigate = _useAIAnswerContext.onNavigate;
  var expandRecentWorkList = useCallback(function () {
    setExpanded(true);
    updateContextCache({
      recentWorkListExpanded: true
    });
  }, [updateContextCache]);
  var onLinkClick = useCallback(function (event) {
    onNavigate(event);
    fireAnalyticsEvent(onRecentWorkLinkClick(commonAttributes));
  }, [fireAnalyticsEvent, commonAttributes, onNavigate]);
  var onLinkContextMenuClick = useCallback(function (event) {
    onNavigate(event);
    fireAnalyticsEvent(onRecentWorkLinkContextMenuClick(commonAttributes));
  }, [fireAnalyticsEvent, commonAttributes, onNavigate]);
  var showExpandedItems = activities.length > COLLAPSED_RECENT_WORK_ITEM_NUMBER ? expanded : true;
  var shownActivities = showExpandedItems ? activities : activities.slice(0, COLLAPSED_RECENT_WORK_ITEM_NUMBER);
  if (activities.length === 0) {
    return /*#__PURE__*/React.createElement(EmptyStateTextWrapper, null, formatMessage(messages.no_activity_error_text, {
      user: name
    }));
  }
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(RecentWorkListTitle, null, formatMessage(messages.recentWorkListTitle)), /*#__PURE__*/React.createElement(RecentWorkListWrapper, null, shownActivities.map(function (activity, index) {
    return /*#__PURE__*/React.createElement(RecentWorkItem, {
      key: "recent-work-item-".concat(index),
      index: index,
      title: activity.title,
      iconUrl: activity.iconUrl,
      url: activity.url,
      container: activity.containerName,
      event: activity.event,
      contributors: activity.contributors,
      timestamp: activity.timestamp,
      othersCount: activity.othersCount
    });
  })), showExpandedItems ? /*#__PURE__*/React.createElement(LinkWrapper, null, /*#__PURE__*/React.createElement(Button, {
    appearance: 'link',
    href: viewAllUrl,
    onClick: onLinkClick,
    onContextMenu: onLinkContextMenuClick
  }, formatMessage(messages.viewAllLink))) : /*#__PURE__*/React.createElement(Fragment, null, !!viewAllUrl && /*#__PURE__*/React.createElement(LinkWrapper, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    onClick: expandRecentWorkList
  }, formatMessage(messages.showMore)))));
};